import React from 'react'

import { Container } from './styles'

export const Toolbar: React.FC = () => {
  return <Container>{/** */}</Container>
}
